module.exports = __webpack_public_path__ + "static/media/gogo-capa.a8937944.png";